// react, hooks
import { Fragment, useEffect, useState } from "react";
import { useInputValue } from "hooks/use-input-value";
import useAuth from "hooks/use-auth";
import useHttp from "hooks/use-http";

// routes
import { useNavigate } from "react-router-dom";

// material styles
import {
  Button,
  FormControl,
  Stack,
  TextField,
  IconButton,
  InputAdornment,
} from "@mui/material";

// material icons
import { Visibility, VisibilityOff } from "@mui/icons-material";

// react icons
import { MdRefresh } from "react-icons/md";

// request methods

// components
import { Wrapper } from "components/shared/Wrapper";
import LoadingCM from "components/shared/Loading";
import ImgContainer from "components/shared/Image";

// helpers
import Toast from "helper/toast";
import { convertNum } from "helper/convert-num";

// style component
import {
  StyledBox,
  StyledBoxContainer,
  StyledImgContainer,
  StyledStack,
} from "./Login.style";

// images
import Captcha from "captcha-image";
import logo from "assets/img/logo-512.png";
import { loginRequest } from "api/login";

export default function Login() {
  const navigate = useNavigate();

  const { request, loading, setLoading } = useHttp(true);

  const name = useInputValue("");
  const password = useInputValue("");
  const captcha = useInputValue("");

  // captcha state
  const [randomCaptcha, setRandomCaptcha] = useState({ image: "", word: "" });

  // password visibility icon state
  const [toggle, setToggle] = useState({ passwordVisibility: false });

  const authCTX = useAuth();

  // password visible handler method
  const handleChange = () =>
    setToggle({ passwordVisibility: !toggle.passwordVisibility });

  // submit method
  const handleSubmit = async () => {
    if (
      [
        name.value.trim().replace(/\s/g, ""),
        password.value.trim().replace(/\s/g, ""),
        captcha.value.trim().replace(/\s/g, ""),
      ].includes("")
    ) {
      return Toast({ type: "empty", title: "لطفا تمام فیلد " });
    }
    if (captcha.value.trim().replace(/\s/g, "") !== randomCaptcha.word)
      return Toast({ type: "custom", title: " کد امنیتی وارد شده اشتباه است" });
    let res = await request({
      url: loginRequest,
      values: { username: name.value, password: convertNum(password.value) },
    });
    if (res) {
      authCTX.login(res.key);
      navigate("/");
    }
  };

  // generate captcha method
  const generateCaptcha = () => {
    const captchaImage = new Captcha(
      "35px IranSans",
      "center",
      "middle",
      150,
      50,
      "#eee",
      "#111",
      6
    ).createImage();

    function createMarkup(source) {
      return { __html: source };
    }

    function MyCaptcha() {
      return <div dangerouslySetInnerHTML={createMarkup(captchaImage)} />;
    }

    let randomWord = captchaImage.split("data-key")[1].split('"')[1];

    setRandomCaptcha({ image: <MyCaptcha />, word: randomWord });

    setLoading(false);
  };

  useEffect(() => {
    generateCaptcha();
  }, []);

  return (
    <Fragment>
      {loading && <LoadingCM />}
      <Wrapper>
        <StyledStack spacing={10} p={4}>
          <ImgContainer
            src={logo}
            alt="لوگو"
            objectFit="contain"
            width="100px"
          />
          <FormControl>
            <Stack spacing={2} justifyContent="center" alignItems="center">
              <TextField
                id="username"
                label="نام کاربری"
                variant="outlined"
                fullWidth
                size="small"
                {...name}
              />
              <TextField
                id="password"
                label="رمز عبور"
                variant="outlined"
                fullWidth
                size="small"
                {...password}
                type={toggle.passwordVisibility ? "text" : "password"}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleChange}
                      >
                        {toggle.passwordVisibility && <Visibility />}
                        {!toggle.passwordVisibility && <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
              <Stack
                display="flex"
                flexDirection="row"
                justifyContent="space-between"
              >
                <TextField
                  id="captcha"
                  label="کد امنیتی"
                  variant="outlined"
                  sx={{ width: "65%" }}
                  size="small"
                  {...captcha}
                />
                <StyledBoxContainer item>
                  <StyledBox>{randomCaptcha.image}</StyledBox>
                  <MdRefresh size={22} onClick={generateCaptcha} />
                </StyledBoxContainer>
              </Stack>
              <Button variant="contained" onClick={handleSubmit} fullWidth>
                ورود
              </Button>
            </Stack>
          </FormControl>
        </StyledStack>
        <StyledImgContainer src={logo} alt="لوگو" objectFit="contain" />
      </Wrapper>
    </Fragment>
  );
}
